import {
  IconButton,
  AddIcon,
} from "@tandemdiabetes/sugarmate-react-components"
import { useCallback } from "react"
import { usePhoneNumberModalContext } from "src/components"
import { usePolyglot } from "src/contexts"

export function AddPhoneNumberButton() {
  const { openPhoneNumberModal } = usePhoneNumberModalContext()
  const polyglot = usePolyglot()

  const onClick = useCallback(
    () => {
      openPhoneNumberModal()
    },
    [openPhoneNumberModal],
  )

  return (
    <IconButton
      onClick={onClick}
      aria-label={polyglot.t("pages.alerts.phone_number.add_button_aria_label")}
    >
      <AddIcon />
    </IconButton>
  )
}
